import { avatarFill, type ChipPerson, initials } from "../lib/people.ts";

/**
 * Pilha de avatares do card events Ofative (58:2316).
 *
 * Medidas do Figma: elipse 20×20, gap −4, anel branco 1px, overflow `+N` em
 * `#F5F3F3` / `#0074FF`. A cápsula branca (raio 30, padding 1) envolve a fila.
 */

const MAX_FACES = 4;

export function AvatarStack({
  people,
  size = 20,
  className,
}: {
  people: ChipPerson[];
  size?: number;
  className?: string;
}) {
  if (people.length === 0) return null;

  const overflow = people.length > MAX_FACES ? people.length - (MAX_FACES - 1) : 0;
  const faces = overflow > 0 ? people.slice(0, MAX_FACES - 1) : people.slice(0, MAX_FACES);

  return (
    <span
      className={["dream-avatar-stack", className].filter(Boolean).join(" ")}
      style={{ ["--dream-avatar-size" as string]: `${size}px` }}
      aria-hidden="true"
    >
      {faces.map((person, index) => {
        const fill = avatarFill(person);
        const src = person.imageUrl?.trim() ?? "";
        return (
          <span
            key={person.id ?? `${person.name}:${person.imageUrl ?? ""}`}
            className="dream-avatar-stack__face"
            title={person.name}
            style={{ backgroundColor: fill, zIndex: faces.length - index }}
          >
            {src !== "" ? (
              <img alt="" src={src} referrerPolicy="no-referrer" />
            ) : (
              <span className="dream-avatar-stack__initials">{initials(person.name)}</span>
            )}
          </span>
        );
      })}
      {overflow > 0 ? (
        <span className="dream-avatar-stack__more" title={`${overflow} a mais`}>
          +{overflow}
        </span>
      ) : null}
    </span>
  );
}
